declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_array_number_foo extends $mol_object {
		bar( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=array_number.view.tree.d.ts.map